// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__+Oi9n","title":"CampaignPopUp_title__lDzIC","alert":"CampaignPopUp_alert__gwL3r","close-btn":"CampaignPopUp_close-btn__sUDOJ"};